import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TALK_EXPERT_FORM_TYPE } from 'src/app/collection-infrastructure/collection-infrastructure.enums';
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { MessageService } from 'src/app/common/services/message.service';
import { TALK_TO_EXPERT } from 'src/defaultImages.js';

@Component({
  selector: 'app-talk-expert-form',
  templateUrl: './talk-expert-form.component.html',
  styleUrls: ['./talk-expert-form.component.css'],
})
export class TalkExpertFormComponent implements OnInit {
  @Input() subscription;
  restaurantId: string;
  isLoader: boolean = false;
  restData: any;
  expertForm: FormGroup;
  isSubmitting: boolean = false; // Add this variable for loader
  translationText: any = {};
  type : string = ''
  images = {
    TALK_TO_EXPERT: TALK_TO_EXPERT,
  };

  formFields = [
    {
      label: 'Restaurant Name',
      placeholder: 'Restaurant Name',
      name: 'restaurantName',
      inputType: 'text',
      validators: [Validators.required], // Add validators directly to the object
    },
    {
      label: 'Restaurant PIC Name',
      placeholder: 'Restaurant PIC Name',
      name: 'picName',
      inputType: 'text',
      validators: [Validators.required], // Add validators directly to the object
    },
    { label: 'Email Address', placeholder: 'MrFish@gmail.com', name: 'email', inputType: 'email', validators: [Validators.required, Validators.email] }, // Add validators directly to the object
    { label: 'Mobile No', placeholder: '+61 12345678', name: 'mobile', inputType: 'tel', validators: [Validators.required] }, // Add validators directly to the object
  ];;

  constructor(
    private _fb: FormBuilder,
    private _localStorage: LocalStorageService,
    private _modalRef: NzModalRef,
    private _translate: TranslateService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _msg: MessageService
  ) {
    this.restaurantId = this._localStorage.get('restaurant_id');
  }

  ngOnInit() {
    this.type = this.subscription ? TALK_EXPERT_FORM_TYPE.SUBSCRIPTION : TALK_EXPERT_FORM_TYPE.NEGATIVE_BALANCE
    this.patchForm();
    this._translate.get('EXPERT_FORM').subscribe((translations) => {
      this.translationText = translations || {};
      this.formFields = [
        {
          label: this.translationText.YOUR_FULL_RESTAURANT_NAME,
          placeholder: this.translationText.YOUR_FULL_RESTAURANT_NAME,
          name: 'restaurantName',
          inputType : 'text',
          validators: [Validators.required]
        },
        {
          label: this.translationText.RESTAURANT_PIC_NAME,
          placeholder: this.translationText.RESTAURANT_PIC_NAME,
          name: 'picName',
          inputType : 'text',
          validators: [Validators.required]
        },
        {
          label: this.translationText.EMAIL_ADDRESS,
          placeholder: 'Mrish@gmail.com',
          name: 'email',
          inputType : 'email',
          validators: [Validators.required , Validators.email]
        },
        {
          label: this.translationText.MOBILE_NO,
          placeholder: this.translationText.MOBILE_NO,
          name: 'mobile',
          inputType : 'tel',
          validators: [Validators.required]
        },
      ];
      this.initForm();
    });
  }

  dismissModal(value?) {
    this._modalRef.close({ success: value });
  }

  initForm() {
    const formControls = {};
    this.formFields.forEach((field) => {
      formControls[field.name] = ['', field.validators];
    });
    this.expertForm = this._fb.group(formControls);
  }

  patchForm() {
    this._collectionInfraService
      .patchForm(this.restaurantId , this.type)
      .then((response) => {
        if ((response || {}).formValue) {
          this.expertForm.patchValue((response || {}).formValue);
          this.restData = (response || {}).restData;
        }
      })
      .catch((error) => {
        console.error(error);
        // Implement error handling here (e.g., show a user-friendly error message)
      });
  }

  async submitToExpert() {
    this.expertForm.markAllAsTouched();
    if (this.expertForm.valid) {
      let formValue = this.expertForm.value;
      const payload = {
        restaurantName: formValue.restaurantName,
        dealId: (this.restData || {}).dealId,
        picName: formValue.picName,
        picPhoneNumber: formValue.mobile,
        picEmail: formValue.email,
        outstandingBalance: (this.restData || {}).outstandingBalance,
        type: this.type
      };
      this.isSubmitting = true; // Show the loader
      try {
        const success = await this._collectionInfraService.submitToExpert(
          this.restaurantId,
          payload
        );
        if (success) {
          this.dismissModal(1);
        }
      } catch (error) {
        console.error(error);
        this._msg.showError(this.translationText?.OOPS_SEC_ERROR_OCC);
        // Implement error handling here (e.g., show a user-friendly error message)
      } finally {
        this.isSubmitting = false; // Hide the loader
      }
    }
  }
}
